module.exports = __webpack_public_path__ + "static/body-builder-d2a5e2789cdb5649785af69a840decce.png";